/**
 * campaign-overview — Campaign Overview report (pipeline snapshot + lead directory).
 *
 * Self-describing template folder: this file is the ONLY thing the registry
 * imports. i18n is 'dictionary' — fixed platform vocabulary translates free
 * from the local dictionary (see i18n.ts); uncovered languages fall back to
 * the reusable AI translator.
 */
import { CAMPAIGN_TEMPLATE, CAMPAIGN_REVISION, validateCampaignReport, translationTexts, validateTranslations, type CampaignReport, type Translations } from '../../schema/campaign';
import { renderCampaignReport } from './render';

export const conf = {
  id: CAMPAIGN_TEMPLATE,
  name: 'Campaign overview',
  description: 'Campaign pipeline status and the complete lead directory.',
  revision: CAMPAIGN_REVISION,
  sourceKinds: ['campaign'] as const,
  pdfBucket: 'campaign-report-exports' as const,
  /** Section config is a lead-report feature; campaigns render fixed content. */
  sectionConfig: false,
  i18n: 'dictionary' as const,
};

export const reportTemplate = {
  conf,
  validate: validateCampaignReport,
  translationTexts: (d: CampaignReport): Translations => translationTexts(d),
  validateTranslations: (d: CampaignReport, t: unknown) => validateTranslations(d, t),
  render: renderCampaignReport,
};
